import { Controller } from "@hotwired/stimulus"

// 候補リスト作成（選択画面）。選択はDBに保存しないので、送信時に1件以上あることだけ確かめる。
export default class extends Controller<HTMLElement> {
  static targets = ["checkbox", "count"]

  declare readonly checkboxTargets: HTMLInputElement[]
  declare readonly countTarget: HTMLElement

  connect() {
    this.refresh()
  }

  refresh() {
    this.countTarget.textContent = this.selectedCount.toString()
  }

  validate(event: Event) {
    if (this.selectedCount > 0) return

    event.preventDefault()
    window.dispatchEvent(new CustomEvent("toast:show", {
      detail: { message: "1件以上選択してください" },
    }))
  }

  private get selectedCount() {
    return this.checkboxTargets.filter((checkbox) => checkbox.checked).length
  }
}
